import { getAgendaConfig, getAgendaConfigs } from '@/api'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    agendaConfig:{}
  },
  getters: {
    Config (state) {
      return state.agendaConfig
    }
  },
  mutations: {
    SET_AGENDA_CONFIG(state,value){
      state.agendaConfig = value
    }
  },
  actions: {
    async getAgendaConfig(context,event_id){
      console.log('vex',event_id);
      const { data } = await getAgendaConfigs(event_id)
      console.log('李阳',data);
      context.commit('SET_AGENDA_CONFIG',data.data)

    }
  },
  modules: {
  }
})
